import React from 'react';
import GeneralNodesSwitch from './GeneralNodesSwitch';

export default class GeneralNodesOverlay extends React.PureComponent {
  render() {
    return (
      <GeneralNodesSwitch {...this.props} />
    );
  }
}
